import { SubscriptionPackage } from "./subscription";
import { BettorBasic } from "common";

export interface StoredSubscriptionData {
  package: SubscriptionPackage;
  capperProfile?: BettorBasic | null;
  originalUrl?: string;
  timestamp: number;
}

const STORAGE_KEY = "pendingSubscription";
const EXPIRY_TIME = 24 * 60 * 60 * 1000;

const SUBSCRIPTION_QUERY_PARAMS = {
  packageId: "sub_pkg_id",
  capperHandle: "sub_capper_handle",
  selectedPlanId: "sub_plan_id",
  returnToSub: "return_to_sub",
};

export function addSubscriptionQueryParams(
  subscriptionPackage: SubscriptionPackage,
  capperHandle?: string,
  selectedPlanId?: string
): void {
  const url = new URL(window.location.href);

  url.searchParams.set(
    SUBSCRIPTION_QUERY_PARAMS.packageId,
    subscriptionPackage.id.toString()
  );
  url.searchParams.set(SUBSCRIPTION_QUERY_PARAMS.returnToSub, "true");

  if (capperHandle) {
    url.searchParams.set(SUBSCRIPTION_QUERY_PARAMS.capperHandle, capperHandle);
  }

  if (selectedPlanId) {
    url.searchParams.set(
      SUBSCRIPTION_QUERY_PARAMS.selectedPlanId,
      selectedPlanId
    );
  }

  window.history.replaceState({}, "", url.toString());
}

export function buildSubscriptionReturnUrl(
  baseUrl: string,
  subscriptionPackage: SubscriptionPackage,
  capperHandle?: string,
  selectedPlanId?: string
): string {
  const url = new URL(baseUrl);

  url.searchParams.set(
    SUBSCRIPTION_QUERY_PARAMS.packageId,
    subscriptionPackage.id.toString()
  );
  url.searchParams.set(SUBSCRIPTION_QUERY_PARAMS.returnToSub, "true");

  if (capperHandle) {
    url.searchParams.set(SUBSCRIPTION_QUERY_PARAMS.capperHandle, capperHandle);
  }

  if (selectedPlanId) {
    url.searchParams.set(
      SUBSCRIPTION_QUERY_PARAMS.selectedPlanId,
      selectedPlanId
    );
  }

  return url.toString();
}

export function getSubscriptionDataFromUrl(searchParams: URLSearchParams): {
  packageId: number;
  capperHandle: string | null;
  selectedPlanId: string | null;
} | null {
  const returnToSub = searchParams.get(SUBSCRIPTION_QUERY_PARAMS.returnToSub);

  if (!returnToSub) return null;

  const packageId = searchParams.get(SUBSCRIPTION_QUERY_PARAMS.packageId);

  if (!packageId) return null;

  const capperHandle = searchParams.get(SUBSCRIPTION_QUERY_PARAMS.capperHandle);
  const selectedPlanId = searchParams.get(
    SUBSCRIPTION_QUERY_PARAMS.selectedPlanId
  );

  return {
    packageId: parseInt(packageId),
    capperHandle,
    selectedPlanId,
  };
}

export function clearSubscriptionQueryParams(url?: string): string {
  const urlObj = new URL(url || window.location.href);

  Object.values(SUBSCRIPTION_QUERY_PARAMS).forEach((param) => {
    urlObj.searchParams.delete(param);
  });

  if (!url) {
    window.history.replaceState({}, "", urlObj.toString());
    console.log("Cleared subscription query params from current URL");
  }

  return urlObj.toString();
}

export function hasSubscriptionQueryParams(
  searchParams: URLSearchParams
): boolean {
  return searchParams.has(SUBSCRIPTION_QUERY_PARAMS.returnToSub);
}
